<div class="sql-generator-container">
  <!-- Customer and Database selectors in top-right with improved styling -->
  <div class="selectors-wrapper">
    <div class="customer-selector-wrapper">
      <app-customer-selector 
        (customerSelected)="onCustomerSelected($event)">
      </app-customer-selector>
    </div>
    <div class="database-selector-wrapper">
      <app-database-selector 
        (databaseSelected)="onDatabaseSelected($event)">
      </app-database-selector>
    </div>
  </div>
  
  <div class="chatbot-container">
    <app-chatbot 
      [config]="chatConfig"
      (messageReceived)="onMessageReceived($event)"
      (playButtonClicked)="onPlayButtonClicked($event)"
      (createDatasetClicked)="onCreateDatasetClicked($event)">
    </app-chatbot>
  </div>
</div>

<!-- Execute SQL button and execution controls template -->
<ng-template #executionControls let-sql>
  <div class="execution-controls">
    <button type="button" class="smooth-execute-button" (click)="executeSql(sql)" matTooltip="Execute SQL Query">
      <mat-icon class="execute-icon">refresh</mat-icon>
    </button>
  </div>
</ng-template>
